import { Box, createStyles, Group, Text, UnstyledButton } from "@mantine/core";
import { IconEdit, IconTrash } from "@tabler/icons-react";

const useStyles = createStyles(() => ({
  badge: {
    display: "inline-flex",
    borderRadius: 6,
    padding: "2px 8px",
    fontSize: 11,
    fontWeight: 600,
    fontFamily: "Inter",
    background: "var(--app-tint-amber)",
    color: "var(--app-ink-amber)",
  },
  iconBtn: {
    width: 32,
    height: 32,
    borderRadius: 7,
    display: "grid",
    placeItems: "center",
    color: "var(--app-text-muted)",
    "&:hover": { background: "var(--app-surface-2)" },
    "&:disabled": { opacity: 0.55, cursor: "not-allowed" },
  },
  danger: {
    color: "#B42318",
  },
  statusBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    borderRadius: 6,
    padding: "3px 9px",
    fontSize: 11,
    fontWeight: 600,
    fontFamily: "Inter",
    border: "none",
    background: "transparent",
    "&:disabled": { cursor: "not-allowed" },
  },
  statusActive: {
    background: "#ECFDF3",
    color: "#12B76A",
    cursor: "pointer",
    "&:hover:not(:disabled)": { background: "#D4F5E0" },
  },
  statusInactive: {
    background: "#F2F4F7",
    color: "var(--app-text-muted)",
    cursor: "pointer",
    "&:hover:not(:disabled)": { background: "#E5E7EB" },
  },
  statusDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "currentColor",
  },
}));

const ActivityLibraryTableRow = ({ row, onEdit, onDelete, onToggle }) => {
  const { classes, cx } = useStyles();
  // General/system-seeded activities are shared across admins, so they can't
  // be edited or deleted here — but each admin can still hide one from their
  // own Quick Notes picker via the Status toggle (see onToggle).
  const locked = !!row.isgeneral;

  return (
    <tr>
      <td>
        <Text fz={14} ff="Inter">{row.name || "-"}</Text>
        <Text fz={11} c="var(--app-text-muted)" ff="Inter" mt={2}>{row.section}</Text>
      </td>
      <td>
        <Box component="span" className={classes.badge}>
          {row.type || "-"}
        </Box>
      </td>
      <td>
        <UnstyledButton
          className={cx(classes.statusBadge, row.active ? classes.statusActive : classes.statusInactive)}
          title={row.active ? "Deactivate" : "Activate"}
          onClick={() => onToggle(row, !row.active)}
        >
          <Box component="span" className={classes.statusDot} />
          {row.active ? "Active" : "Inactive"}
        </UnstyledButton>
      </td>
      <td>
        <Group spacing={6} position="right" noWrap>
          <UnstyledButton className={classes.iconBtn} disabled={locked} onClick={() => !locked && onEdit(row)}>
            <IconEdit size={16} />
          </UnstyledButton>
          <UnstyledButton
            className={cx(classes.iconBtn, classes.danger)}
            disabled={locked}
            onClick={() => !locked && onDelete(row)}
          >
            <IconTrash size={16} />
          </UnstyledButton>
        </Group>
      </td>
    </tr>
  );
};

export default ActivityLibraryTableRow;
